import { withViewComponent } from '@updater-local/custom-element-v1';
import '@updater-components/phone-formatter';
import '../../components/company-info';
import '../../components/company-contact-card';
import styles from './index.css';
import { when } from '../../utils';

export default class CompanyContactList extends withViewComponent(styles)() {
  static props = ['value', 'companySelection'];

  updated({ value = [], companySelection }) {
    // prettier-ignore
    this.render`
      ${value.map(company => this.wire(company.id)`
        <div class="company-container">
          <upd-moveiq-company-info
            class="${companySelection ? 'tall' : ''}"
            value="${company}"
            companySelection="${companySelection ? {
              isSelected: company.status === 'inflight'
            } : false}"
          >
          </upd-moveiq-company-info>
          ${when(!companySelection, () => this.wire()`
            <upd-moveiq-company-contact-card value="${company}"></upd-moveiq-company-contact-card>
          `)}
        </div>
      `)}
    `;
  }
}

customElements.define('upd-moveiq-company-contact-list', CompanyContactList);
